import axios from "axios";
import Cookie from "./Cookie";

export const pyrotchBaseUrl =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8888/";

let token: string;

export const getToken = async () => {
  // const cookie1 = await Cookie().getCookie("_1fj2Ew");
  // const cookie2 = (await Cookie().getCookie("_JdgE54")) || "";
  // const cookie3 = await Cookie().getCookie("_3mhb65");

  // if (cookie1) {
  //   token = `${cookie1}.${window.atob(cookie2)}.${cookie3}`;
  // }

  return localStorage.getItem("authToken");
};

export const axiosInstance = axios.create({
  baseURL: pyrotchBaseUrl,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    if (config.data instanceof FormData) {
      if (typeof (config.headers as any).delete === "function") {
        (config.headers as any).delete("Content-Type");
      } else {
        delete (config.headers as any)["Content-Type"];
        delete (config.headers as any)["content-type"];
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response.data.data;
  },
  (error) => {
    const requestUrl = error.config?.url || "";
    const isProductLibrarySsoRequest = requestUrl.includes("auth/product-library/sso-code");
    if (
      !isProductLibrarySsoRequest &&
      error.response &&
      error.response.data &&
      (error.response.data.message === "Unauthorized" ||
        error.response.status === 401)
    ) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("name");
      const publicUrl = process.env.PUBLIC_URL;
      const loginPath = publicUrl && publicUrl !== "." ? `${publicUrl}/login` : "/login";
      window.location.href = loginPath;
    }
    return Promise.reject(error);
  }
);

export const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: "" }) =>
  async ({ url, method, data, params, headers }: any) => {
    try {
      console.log("=== AXIOS REQUEST ===");
      console.log("Full URL:", baseUrl + url);
      console.log("Method:", method);
      if (data instanceof FormData) {
        const entries = Array.from(data.entries()).map(([key, value]) => ({
          field: key,
          value: value instanceof File ? `${value.name} (${value.size} bytes)` : value,
        }));
        console.log("Data (FormData):", entries);
      } else {
        console.log("Data (body):", JSON.stringify(data, null, 2));
      }
      console.log("Params:", params);
      console.log("Headers:", headers);
      
      const result = await axiosInstance({
        url: baseUrl + url,
        method,
        data,
        params,
        headers,
      });
      
      console.log("=== AXIOS RESPONSE ===");
      console.log("Response:", result);
      
      return { data: result };
    } catch (axiosError: any) {
      console.log("=== AXIOS ERROR ===");
      console.log("Error:", axiosError);
      console.log("Error response:", axiosError.response);
      console.log("Error data:", axiosError.response?.data);
      
      return {
        error: {
          status: axiosError.response?.status,
          data: axiosError.response?.data || axiosError.message,
        },
      };
    }
  };
